import { WalletStateInterface } from "./types";
import VuetifySelectItems from '@/types/app/vuetifySelectItems';


export default {
  setSelectProductsState(
    state: WalletStateInterface,
    selectProducts: VuetifySelectItems[]
  ) {
    state.selectProducts = selectProducts;
  },
  setSelectFundsState(
    state: WalletStateInterface,
    selectFunds: VuetifySelectItems[]
  ) {
    state.selectFunds = selectFunds;
  }
};

